import { setAltTextFeatureEnabled } from '~/utils/altTextFeature'

/**
 * Bakes `NUXT_PUBLIC_ALT_TEXT_ENABLED` into client + server alt resolution at startup.
 */
export default defineNuxtPlugin((nuxtApp) => {
  setAltTextFeatureEnabled(nuxtApp.$config?.public?.altTextEnabled === true)
})
